export default "__VITE_ASSET__CD5Wmh2x__"